import { createSlice } from '@reduxjs/toolkit';

const leadData = {
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  address: {
    postalCode: '',
    state: '',
    city: '',
    line1: '',
    line2: '',
    country: '',
  },
  contractFlowToken: '',
  dateOfBirth: '',
  sex: '',
  socialSecurityNumber: '',
  uuid: '',
  occupation: '',
  timeWorking: '',
  currentEmployer: '',
  employerPhoneNumber: '',
  employerAddress: '',
  grossYearlyIncome: '',
  otherIncome: '',
  otherIncome_source: undefined,
  bankruptcy: false,
  bankruptcyType: '',
  discharged: false,
  surrendedOrRepossessed: false,
  referralCode: '',
  referralCodeShortDescription: '',
  maritalStatus: '',
  clubId: '',
  bankAccountVerified: false,
  plaidPublicToken: '',
  plaidAccountId: '',
  userUuid: '',
  dealValue: 0,
  term: '84',
  weekTerm: '364',
  weeklyCycle: false,
  group: {
    id: '',
    name: '',
  },
  firstTimeToken: '',
  hasPassword: false,
  userPhone: '',
  defaultPaymentSource: '',
  paymentMethodLast4: '',
  contractFlowMonthlyPayment: 0,
  contractFlowWeeklyPayment: 0,
  totalSavings: 0,
  referralCodeSavings: 0,
  contractFlowManagementFee: 0,
  contractFlowHalfPaymentSelected: false,
  halfPayment: 0,
  creditScoreCategory: '',
  contractFlowDownPayment: 0,
  contractFlowStep: 0,
  creditScore: 0,
  contractFlowApy: 0,
  subscribed: false,
  paymentLink: "",
  founderInvite: false,
  toWaitingList: false,
  contractSigned: false,
  contractFlowFirstPayment: null as null | number,
  seats: 1,
};

export const leadSlice = createSlice({
  name: 'lead',
  initialState: {
    currentStep: 0,
    wasDiscountShown: false,
    leadData,
    firstTimeToken: '',
    isPlaidCompleted: false,
    creditCardValidated: false,
    paymentOption: 'plaid',
    subscribedOnWaitingList: false,
    inviteSent: false,
  },
  reducers: {
    setLeadData: (state, action) => {
      return ({
        ...state,
        ...action.payload,
        leadData: {
          ...state.leadData,
          ...action.payload?.leadData,
        },
      })
    },
    setLeadDataContractFlowMonthlyPayment: (state, action) => ({
      ...state,
      leadData: {
        ...state.leadData,
        contractFlowMonthlyPayment: action.payload,
      },
    }),
  },
});

export const { setLeadData, setLeadDataContractFlowMonthlyPayment } =
  leadSlice.actions;

export default leadSlice.reducer;
